export const SubmissionToEwaCompleteDialogMessage = {
    modalTitle: 'Submission Complete!',
    modalContent: 'Check the dashboard for status updates.',
    primaryActionTitle: 'Return to Dashboard',
} as const;

export const SubmissionToEwaWithResultCompleteDialogMessage = {
    modalTitle: 'Submission Complete!',
    primaryActionTitle: 'Proceed to Order Details',
} as const;

export const SubmissionToFccCompleteDialogMessage = {
    modalTitle: 'Submission Complete!',
    primaryActionTitle: 'Return to Dashboard',
} as const;

export const SubmissionToEwaAttachmentRequiredDialogMessage = {
    modalTitle: 'Attachment Missing',
    content:
        'You have identified that an attachment will be sent with this application, but none are present. Would you still like to submit the application without an attachment?',
    primaryActionTitle: 'Submit Without Attachment',
} as const;

export const SubmissionToFccAttachmentRequiredDialogMessage = {
    modalTitle: 'Attachments',
    content:
        'You have identified in Question 8 that an attachment will be sent with this application, but none are present. Please add an attachment or update Question 8 before submitting to the FCC.',
} as const;

export const SubmissionToFccFailedValidationDialogMessage = {
    modalTitle: 'Submit to FCC: Validation Failed',
    content:
        'Your application has not passed validation. Return to the application to make required changes.',
    primaryActionTitle: 'Return to Application',
} as const;

export const SubmissionToFccNoSelectedFrequenciesDialogMessage = {
    modalTitle: 'Submit to FCC: No Frequencies Selected',
    errorContent:
        'No frequencies have been selected. Please select at least one frequency before continuing.',
    warningContent:
        'No frequencies have been selected. Are you sure you want to submit the application without selecting any frequencies?',
    primaryActionTitle: 'Return to Application',
    secondaryActionTitle: 'Continue Submission',
} as const;

export const FrnFilingHandoverToEwaIncompleteDialogMessage = {
    modalTitle: 'Hand Over to EWA',
    content:
        'All fields are not complete. Are you sure you want to hand over to EWA?',
    primaryActionTitle: 'Hand Over to EWA',
    cancelTitle: 'Return to FRN Request',
} as const;

export const SubmissionToPscaCompleteDialogMessage = {
    modalTitle: 'Submission Complete!',
    primaryActionTitle: 'Return to Dashboard',
} as const;

export const SubmissionToPscaFailedValidationDialogMessage = {
    modalTitle: 'Submit to PSCA: Validation Failed',
    content:
        'Your application has not passed validation. Return to the application to make required changes.',
    primaryActionTitle: 'Return to Application',
};

export const SubmissionEmailVerificationRequiredDialogMessage = {
    modalTitle: 'Email Verification Notification',
    content:
        "The user you are submitting this application for has not verified their email address. EWA requires all users to have a verified email address, to receive our e-notices and confirmations from the FCC, for example.<br /><br />You can resend the verification email and then check the user's status in their profile before submitting. The resend verification email will be sent to <strong>{emailAddress}</strong>.<br /><br />If you need to submit this application immediately, you can continue without verification. This will submit the application.",
    primaryAction: {
        title: 'Resend Email, Hold App',
        name: 'resendVerificationEmail',
    },
    secondaryAction: {
        title: 'Submit Without Verification',
        name: 'submitWithoutVerification',
    },
} as const;
